import React, { useEffect } from "react";
import { Footer, Header } from "../../components";
import { ENROL_URL } from "../../constants/journey";
import { C, FONT } from "../../constants/mq";

// /enroll is a doorway, not a page.
//
// It used to be a seven-step wizard on this site: sign up, pick courses,
// choose a campus, see a fee summary. None of it worked — the sign-up posted
// to a hardcoded IP address that no longer resolves, and the course and fee
// steps were never wired to anything. Meanwhile the portal holds the accounts,
// the timetable and the fee tables, so that is where enrolment belongs.
//
// The path stays because it is linked from every header, footer and course
// page, and printed on material we do not control.

const s = {
  main: {
    minHeight: "52vh", display: "flex", alignItems: "center",
    justifyContent: "center", padding: "80px 24px", background: "#fff",
    fontFamily: FONT,
  },
  inner: { textAlign: "center", maxWidth: 520 },
  h1: {
    fontSize: 28, fontWeight: 800, color: C.ink, margin: "0 0 12px",
    letterSpacing: "-0.5px",
  },
  body: { fontSize: 15, color: C.body, lineHeight: 1.7, margin: "0 0 26px" },
};

const EnrollPage = () => {
  useEffect(() => {
    // Replace rather than assign, so Back returns to the page they came from
    // instead of bouncing them forward again.
    window.location.replace(ENROL_URL);
  }, []);

  return (
    <div style={{ background: "#fff" }}>
      <Header />
      <main style={s.main}>
        <div style={s.inner}>
          <h1 style={s.h1}>Taking you to enrolment&hellip;</h1>
          <p style={s.body}>
            If nothing happens in a moment, use the button below.
          </p>
          <a href={ENROL_URL} className="mq-btn">Enrol now</a>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default EnrollPage;
